<template>
  <div :class="model.background">
    <div class="container mx-auto flex max-w-screen-xl flex-col justify-between py-8 lg:flex-row lg:py-16">
      <div class="contact-block__content flex flex-wrap justify-between lg:w-1/3 lg:pr-8">
        <div v-for="(item, index) in model.addresses" :key="index" class="w-1/2">
          <div v-if="item.title" class="font-bold">
            {{ item.title }}
          </div>
          <div v-if="item.text" v-html-safe="item.text"></div>
        </div>
      </div>
      <div class="contact-block__item lg:w-2/3" v-html-safe="model.iframeUrl"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
.contact-block__item iframe {
  @apply rounded-xl;
  height: 325px;
}
</style>
